import {Component} from '@angular/core';
import {RouterOutlet} from '@angular/router';
import {ConfirmDialog} from 'primeng/confirmdialog';
import {Toast} from 'primeng/toast';

@Component({
  selector: 'homey-root',
  standalone: true,
  imports: [RouterOutlet, ConfirmDialog, Toast],
  templateUrl: './app.component.html',
})
export class AppComponent {
  title = 'homey-admin-v2-app';
}
